import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { AppService } from "src/app/core/services/app.service";
import { FocuslinkService } from "src/app/core/services/focuslink.service";
import { OOVenueService } from "src/app/core/services/venue-service";
import { AppMessageSeverity } from "src/app/shared/models/enums/AppMessageSeverity.enum";
import { Store } from "src/app/shared/models/store";

@Component({
	selector: "app-dealer-venue-tool-options",
	templateUrl: "./dealer-venue-tool-options.component.html",
	styleUrls: ["../../../commandcenter.scss"],
})
export class DealerVenueToolOptionsComponent implements OnInit {
	@Input() venueSelected: Store;
	@Output() venueSelectedChange = new EventEmitter<Store>();

	selectedPosConfigKey: string;
	selectedPosLinkLogKey: string;
	selectedVenueDeviceId: number;

	constructor(public app: AppService, public venueService: OOVenueService, private focuslink: FocuslinkService) {}

	ngOnInit(): void {}

	async onDownloadPosConfigArchive(key: string) {
		const obj = await this.focuslink.utilityS3SignedUrl(`focuspos-focuslink-storeconnector-logs`, key);
		console.log(obj);
		window.open(obj.url, "_blank");
	}

	async onDeviceSoftwareRestart() {
		this.app.confirmation.confirm({
			message: `Are you sure you want to restart Focus on ${
				this.venueSelected.status.stationStatus.find((i) => i.deviceId === this.selectedVenueDeviceId).name
			}?`,
			accept: async () => {
				this.focuslink.posDeviceRestartReboot(this.venueSelected.key, this.selectedVenueDeviceId, "restart");
				this.app.msgSvc.add({
					severity: AppMessageSeverity.GREEN,
					summary: "",
					detail: `Restart request sent to ${this.venueSelected.status.stationStatus.find((i) => i.deviceId === this.selectedVenueDeviceId).name}.`,
				});
			},
			reject: async () => {
				this.app.confirmation.close();
			},
		});
	}

	async onDeviceReboot() {
		this.app.confirmation.confirm({
			message: `Are you sure you want to reboot ${this.venueSelected.status.stationStatus.find((i) => i.deviceId === this.selectedVenueDeviceId).name}?`,
			accept: async () => {
				this.focuslink.posDeviceRestartReboot(this.venueSelected.key, this.selectedVenueDeviceId, "reboot");
				this.app.msgSvc.add({
					severity: AppMessageSeverity.GREEN,
					summary: "",
					detail: `Reboot request sent to ${this.venueSelected.status.stationStatus.find((i) => i.deviceId === this.selectedVenueDeviceId).name}.`,
				});
			},
			reject: async () => {
				this.app.confirmation.close();
			},
		});
	}
}
